import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import UiIcon from "../components/UiIcon";
import { Screen, PageHeader, RoundButton, Chip, Button, K } from "../components/UiKit";

// "Mes anniversaires" — miroir de OLTODO/app/birthday-events.tsx : uniquement les événements où
// je suis organisateur ou invité, jamais ceux dont je suis le/la fêté(e) (garde du mode surprise,
// imposée côté backend par routes/birthdayEvents.ts).
export default function BirthdayEvents() {
  const navigate = useNavigate();
  const { lang } = useApp();
  const [events, setEvents] = useState<any[] | null>(null);

  useEffect(() => {
    api.get("/birthday-events/mine").then(d => setEvents(d?.events || [])).catch(() => setEvents([]));
  }, []);

  const fmt = (d: string) => new Date(d).toLocaleDateString(lang, { weekday: "short", day: "numeric", month: "short" });

  return (
    <Screen>
      <PageHeader title={t(lang, "bday_list_title")} onBack={() => navigate(-1)} right={<RoundButton icon="plus" dark label={t(lang, "bday_create_title")} onClick={() => navigate("/birthday-events/create")} />} />

      {events === null ? (
        <div style={{ textAlign: "center", color: K.faint, marginTop: 40 }}>{t(lang, "msg_loading")}</div>
      ) : events.length === 0 ? (
        <div style={{ textAlign: "center", padding: "48px 12px 0" }}>
          <div style={{ width: 72, height: 72, borderRadius: 36, backgroundColor: K.surface, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", color: K.ink }}>
            <UiIcon name="cake" size={32} />
          </div>
          <div style={{ fontSize: 14.5, color: K.muted, lineHeight: 1.5, marginBottom: 22 }}>{t(lang, "bday_list_empty")}</div>
          <Button icon="plus" onClick={() => navigate("/birthday-events/create")}>{t(lang, "bday_create_title")}</Button>
        </div>
      ) : (
        events.map(e => (
          <div key={e.id} onClick={() => navigate(`/birthday-events/${e.id}`)} style={{ display: "flex", alignItems: "center", gap: 14, border: `1px solid ${K.line}`, backgroundColor: K.white, borderRadius: 16, padding: 14, marginBottom: 10, cursor: "pointer", minWidth: 0 }}>
            <div style={{ width: 52, height: 52, borderRadius: 26, backgroundColor: K.surface, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0, color: K.ink }}>
              {e.birthday_user_avatar ? <img src={e.birthday_user_avatar} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : <UiIcon name="cake" size={24} />}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: K.ink }}>{e.title}</div>
              {e.event_date && (
                <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12.5, color: K.muted, marginTop: 3 }}>
                  <UiIcon name="calendar" size={13} />{fmt(e.event_date)}
                </div>
              )}
              <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
                <Chip ink={e.my_role === "organizer"} icon={e.my_role === "organizer" ? "user" : "userPlus"}>{e.my_role === "organizer" ? t(lang, "bday_role_organizer") : t(lang, "bday_role_guest")}</Chip>
                {!!e.is_surprise && <Chip icon="sparkle">{t(lang, "bday_surprise_tag")}</Chip>}
              </div>
            </div>
            <UiIcon name="chevronRight" size={18} color={K.faint} />
          </div>
        ))
      )}
    </Screen>
  );
}
